import React, { useMemo } from 'react';
import { Casa, Tarea, TareaHecha } from '../../types';
import { estrellasPeques } from '../../utils/repartoTareas';
import { lunesDe, mediodia } from '../../utils/tareas';
import { Star } from 'lucide-react';

/**
 * Las estrellas de los peques de una casa: cada tarea que hacen suma su
 * esfuerzo. Para enseñárselo y celebrarlo; el premio lo ponéis en casa.
 */
export const TarjetaEstrellas: React.FC<{ casa: Casa; tareas: Tarea[]; hechas: TareaHecha[]; conNombre: boolean }> =
  ({ casa, tareas, hechas, conNombre }) => {
  const peques = useMemo(() => {
    const hoy = mediodia(new Date());
    return estrellasPeques(casa, tareas, hechas, lunesDe(hoy), hoy);
  }, [casa, tareas, hechas]);
  if (!peques.length) return null;

  return (
    <section className="rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 p-4">
      <h2 className="flex items-center gap-2 font-bold text-amber-900 dark:text-amber-200">
        <Star className="w-4 h-4 fill-amber-400 text-amber-500" /> Estrellas de los peques{conNombre ? ` · ${casa.nombre}` : ''}
      </h2>
      <ul className="mt-3 space-y-3">
        {peques.map(p => (
          <li key={p.id}>
            <div className="flex items-baseline justify-between gap-2">
              <span className="font-semibold text-gray-900 dark:text-white">{p.nombre}</span>
              <span className="text-sm tabular-nums text-amber-800 dark:text-amber-300">
                <b className="text-lg">{p.semana}</b> ⭐ esta semana · {p.mes} este mes
              </span>
            </div>
            <div className="mt-1 text-lg leading-none tracking-tight" aria-hidden>
              {'⭐'.repeat(Math.min(p.semana, 20))}{p.semana > 20 ? ' …' : ''}
            </div>
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              {p.ultimas.length ? `Esta semana: ${p.ultimas.join(', ')}.` : 'Esta semana aún no ha marcado ninguna.'}
            </p>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[11px] text-gray-500 dark:text-gray-400">
        Cada tarea suma su esfuerzo: poco 1, medio 2, mucho 3. Al marcarla, elige que la ha hecho el peque.
      </p>
    </section>
  );
};
